import * as CatCentersActions from '../adm-cat-centers.actions'
import { IDS } from '../../adm-categorisation-action-id.constants'
import {GRID_RELOAD} from "../../../../../common/grid/grid.constants";
import {TAB_SELECT} from "../../../../../common/tabs/tabs.constants";
/**
 * AdmCatCenterDetailsController.
 * @class
 * @memberOf Administration
 */
class AdmCatCenterDetailsController {
    constructor($ngRedux, $state, $scope, Notifier, NavigationActions, SubjectTypesService) {
        this.$ngRedux           = $ngRedux;
        this.$state             = $state;
        this.$scope             = $scope;
        this.Notifier           = Notifier;
        this.NavigationActions  = NavigationActions;
        this.SubjectTypesService = SubjectTypesService;
    }

    $onInit() {
        this.identifier = IDS.admCategorisation;
        this.unsubscribe = this.$ngRedux.connect(
            state => {
                const formData = state.administration.admCategorisation.admCatCenterDetails
                return {
                    formData,
                    title: formData.sty_id ? 'Center Type Details' : 'Add Center Type',
                    submitButtonLabel: formData.sty_id ? 'Update' : 'Add Center Type',
                }
            },
            CatCentersActions
        )(this);
    }

    onSubmit() {
        this.$scope.$broadcast('show-errors-check-validity', '$ctrl.detailsForm');
        if (this.detailsForm.$valid === false) {
            this.Notifier.error('COMMON.FIELDS_REQUIRED');
            return;
        }
        if (this.formData.sty_id) {
            this.SubjectTypesService.updateSubjectType(this.formData).then(
                (response) => {
                    this.Notifier.success('UPDATE SUCCESS');
                    this.$ngRedux.dispatch({
                        type: GRID_RELOAD,
                        id: this.identifier,
                        path: IDS.admCatCentersGrid,
                    });
                    this.$ngRedux.dispatch({
                        type: TAB_SELECT,
                        id: IDS.app_administration_categorisation_centers,
                        state: IDS.app_administration_categorisation_centers_grid,
                    });
                }
            );
        }
        else {
            // this.SubjectTypesService.addSubjectType($scope.selectSubjectTypeId, null, subjectTypeName).then(
            //     (response) => {
            //         this.Notifier.success('ADD SUCCESS');
            //     }
            // );
        }
    }

    $onDestroy() {
        this.unsubscribe();
    }
}

AdmCatCenterDetailsController.$inject = ['$ngRedux', '$state', '$scope', 'Notifier', 'NavigationActions', 'SubjectTypesService']

export const admCatCenterDetails = {
    controller: AdmCatCenterDetailsController,

    template: `
        <tabs-header title="{{$ctrl.title}}"></tabs-header>
        
        <form id="detailsForm" name="$ctrl.detailsForm" noValidate>
            <div layout-gt-xs="row">
                <input-text-area flex class="noMarginBottom"
                    identifier="{{$ctrl.identifier}}"
                    label="Center Type Name"
                    name="name"
                    state-path="admCatCenterDetails.name"
                    required="true"
                    rows="1"
                    max-length="120"></input-text-area>
            </div>
            <input-checkbox flex
                            name="ahpra_licence_required"
                            identifier="{{$ctrl.identifier}}"
                            state-path="admCatCenterDetails.ahpra_licence_required"
                            label="AHPRA License Required">
            </input-checkbox>
            <input-checkbox flex
                            name="use_licence_required"
                            identifier="{{$ctrl.identifier}}"
                            state-path="admCatCenterDetails.use_licence_required"
                            label="Use License Required">
            </input-checkbox>
            
            <div layout-xs="column"
                layout-sm="column"
                layout-gt-sm="row"
                flex-gt-md="60"
                layout-align="center center">
                    <div flex hide-xs hide-sm></div>
                    <md-button class="btnColorAccreditations"
                        name="btnSubmit" 
                        aria-label="Submit" 
                        ng-click="$ctrl.onSubmit()">{{$ctrl.submitButtonLabel}}</md-button>
            </div>
        </form>`
}
